/**
 * Component Registry - CSS-free imports for hydration
 * 
 * This file imports components without their CSS dependencies
 * for use in the hydration bundle where CSS is already loaded.
 * 
 * Note: This file is intentionally not covered by tests as it's only
 * used at runtime for component hydration in the Lambda environment.
 */

import { Accordion } from './components/Accordion/Accordion';
import { AppDownload } from './components/AppDownload/AppDownload';
import { BrandLogosBanner } from './components/BrandLogosBanner/BrandLogosBanner';
import { Carousel } from './components/Carousel/Carousel';
import { ContentGrid } from './components/ContentGrid/ContentGrid';
import { StepsSection } from './components/StepsSection/StepsSection';
import { Card } from './components/Card/Card';
import { CardGrid } from './components/CardGrid/CardGrid';
import { CookieConsentBanner } from './components/CookieConsentBanner/CookieConsentBanner';
import { CtaButton } from './components/CtaButton/CtaButton';
import { CustomIcon } from './components/CustomIcon/CustomIcon';
import { ContentTable } from './components/ContentTable/ContentTable';
import { FeaturedCards } from './components/FeaturedCards/FeaturedCards';
import { Hero } from './components/Hero/Hero';
import { Image } from './components/Image/Image';
import { InfoBanner } from './components/InfoBanner/InfoBanner';
import { LinkCollection } from './components/LinkCollection/LinkCollection';
import { LeadCapture } from './components/LeadCapture/LeadCapture';
import { MediaSection } from './components/MediaSection/MediaSection';
import { Logo } from './components/Logo/Logo';
import { MegaMenu } from './components/MegaMenu/MegaMenu';
import { MegaMenuData } from './components/MegaMenu/MegaMenuData';
import { MegaMenuBlock } from './components/MegaMenuBlock/MegaMenuBlock';
import { NsiCard } from './components/NsiCard/NsiCard';
import { NotificationBanner } from './components/NotificationBanner/NotificationBanner';
import { PageFooter } from './components/PageFooter/PageFooter';
import { PageFooterData } from './components/PageFooter/PageFooterData';
import { Popup } from './components/Popup/Popup';
import { PreFooter } from './components/PreFooter/PreFooter';
import { Quiz } from './components/Quiz/Quiz';
import { QvpBanner } from './components/QvpBanner/QvpBanner';
import { RichText } from './components/RichText/RichText';
import { SampleBlockWrapper } from './components/SampleBlockWrapper/SampleBlockWrapper';
import { SearchBar } from './components/SearchBar/SearchBar';
import { SearchResults } from './components/SearchResults/SearchResults';
import { SecondaryNav } from './components/SecondaryNav/SecondaryNav';
import { SplitContent } from './components/SplitContent/SplitContent';
import { SideNavLayoutDocument } from './components/SideNavLayoutDocument/SideNavLayoutDocument';
import { SingleColumnLayoutDocument } from './components/SingleColumnLayoutDocument/SingleColumnLayoutDocument';
import { SuperCard } from './components/SuperCard/SuperCard';
import { Table } from './components/Table/Table';
import { Tabs } from './components/Tabs/Tabs';
import { Testimonial } from './components/Testimonial/Testimonial';
import { TestimonialCarousel } from './components/TestimonialCarousel/TestimonialCarousel';

export const ComponentRegistry = {
  'Accordion': Accordion,
  'AppDownload': AppDownload,
  'BrandLogosBanner': BrandLogosBanner,
  'Card': Card,
  'CardGrid': CardGrid,
  'Carousel': Carousel,
  'ContentGrid': ContentGrid,
  'CookieConsentBanner': CookieConsentBanner,
  'StepsSection': StepsSection,
  'CtaButton': CtaButton,
  'CustomIcon': CustomIcon,
  'ContentTable': ContentTable,
  'FeaturedCards': FeaturedCards,
  'Hero': Hero,
  'Image': Image,
  'InfoBanner': InfoBanner,
  'LinkCollection': LinkCollection,
  'LeadCapture': LeadCapture,
  'MediaSection': MediaSection,
  'Logo': Logo,
  'MegaMenu': MegaMenu,
  'MegaMenuData': MegaMenuData,
  'MegaMenuBlock': MegaMenuBlock,
  'NsiCard': NsiCard,
  'NotificationBanner': NotificationBanner,
  'PageFooter': PageFooter,
  'PageFooterData': PageFooterData,
  'Popup': Popup,
  'PreFooter': PreFooter,
  'Quiz': Quiz,
  'QvpBanner': QvpBanner,
  'RichText': RichText,
  'SampleBlockWrapper': SampleBlockWrapper,
  'SearchBar': SearchBar,
  'SearchResults': SearchResults,
  'SecondaryNav': SecondaryNav,
  'SideNavLayoutDocument': SideNavLayoutDocument,
  'SingleColumnLayoutDocument': SingleColumnLayoutDocument,
  'SuperCard': SuperCard,
  'SplitContent': SplitContent,
  'Table': Table,
  'Tabs': Tabs,
  'Testimonial': Testimonial,
  'TestimonialCarousel': TestimonialCarousel,
};